module.exports = __webpack_public_path__ + "img/bad2.a4527166.jpg";